"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNfts = exports.fetchWallets = exports.resetPasswordChangeSuccess = exports.resetPasswordSuccess = exports.refreshUser = exports.startup = exports.logout = exports.setCreateUser = exports.authSuccess = exports.setUserSession = void 0;
const airbridge_web_sdk_loader_1 = __importDefault(require("airbridge-web-sdk-loader"));
const effects_1 = require("redux-saga/effects");
const constants_1 = require("@/constants");
const ApiService_1 = __importDefault(require("@/helpers/ApiService"));
const auth_1 = require("@/helpers/auth");
const history_1 = __importDefault(require("@/helpers/history"));
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const user_1 = require("@/redux/user");
function* setUserSession({ payload }, isSignup) {
    const { data } = payload.data;
    const user = data;
    yield (0, effects_1.call)(() => airbridge_web_sdk_loader_1.default.setUserId(user.id));
    yield (0, effects_1.call)(() => airbridge_web_sdk_loader_1.default.setUserEmail(user.email));
    if (isSignup) {
        airbridge_web_sdk_loader_1.default.events.send('airbridge.user.signup');
    }
    else {
        airbridge_web_sdk_loader_1.default.events.send('airbridge.user.signin');
    }
    yield (0, effects_1.put)({ type: user_1.ACTIONS.STORE_USER, payload: { user: data } });
    yield (0, effects_1.call)(auth_1.setAuth, data.token);
    yield (0, effects_1.call)(ApiService_1.default.setAuthHeader, data.token);
    yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchSubscriptionsPayload)()));
}
exports.setUserSession = setUserSession;
function* authSuccess(action, isSignup = false) {
    yield setUserSession(action, isSignup);
    yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchHabitJourneysPayload)()));
    yield (0, effects_1.call)(history_1.default.push, constants_1.Routes.Home);
}
exports.authSuccess = authSuccess;
function* setCreateUser(action) {
    yield authSuccess(action, true);
}
exports.setCreateUser = setCreateUser;
function* logout() {
    yield (0, effects_1.call)(auth_1.deleteAuth);
    yield (0, effects_1.call)(history_1.default.push, constants_1.Routes.Login);
}
exports.logout = logout;
function* startup() {
    const token = (0, auth_1.getAuth)();
    if (token) {
        yield (0, effects_1.call)(ApiService_1.default.setAuthHeader, token);
        yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.hydrateUserPayload)()));
        yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchSubscriptionsPayload)()));
        yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchHabitJourneysPayload)()));
    }
}
exports.startup = startup;
function* refreshUser() {
    const token = (0, auth_1.getAuth)();
    if (token) {
        yield (0, effects_1.call)(ApiService_1.default.setAuthHeader, token);
        yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.hydrateUserPayload)()));
        yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchHabitJourneysPayload)()));
    }
}
exports.refreshUser = refreshUser;
function* resetPasswordSuccess() {
    yield (0, effects_1.call)(history_1.default.push, constants_1.Routes.ResetPasswordInstructions);
}
exports.resetPasswordSuccess = resetPasswordSuccess;
function* resetPasswordChangeSuccess() {
    yield (0, effects_1.call)(history_1.default.push, constants_1.Routes.Login);
}
exports.resetPasswordChangeSuccess = resetPasswordChangeSuccess;
function* fetchWallets() {
    yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchWalletAddressesPayload)()));
    yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchNftsAddressesPayload)()));
}
exports.fetchWallets = fetchWallets;
function* fetchNfts() {
    yield (0, effects_1.put)(redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.fetchNftsAddressesPayload)()));
}
exports.fetchNfts = fetchNfts;
exports.default = { setUserSession };
